import {
    ApprovalRangeBoundsType,
    ApprovalSubType,
    ApprovalType,
    ApproverPolicy,
    IWorkflowProcessor,
    IWorkflowProcessorExtension,
    IWorkflowValidateOptions,
    IWorkflowValidateTransitionOptions,
    StatusType
} from "../PA.Core/PA.Core.IF.Workflow";
import {ClaimBO} from "./ClaimBO";
import {ASync} from "../PA.Core/Basic/ASync";
import {WB_UserRow} from "../PA.Core/PAdbSchemaRows";
import {WorkflowProcessor} from "../PA.Core/Workflow/WorkflowProcessor";
import {UserSecurityService} from "../PA.Security.Services/UserSecurityService";
import * as _ from 'lodash'
import {esWB_User} from "../PA.Core/PAdbSchema";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {Role_Super_User, Role_TPM_Claim_Editor, Role_TPM_Claim_Approver} from "../PA.Core/Security/Roles";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";

import {PaymentMethod_OffInvoice} from "../PA.TPM.Core/TPM.Constants";
import {NumberUtils} from "../PA.Core/Basic/Numbers";
import {WarningMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {ApprovalService} from "../PA.MD.Services/ApprovalService";
import {DateUtils} from "../PA.Core/Basic/Dates";


export class ClaimBOStandardWorkflowExtension
    implements IWorkflowProcessorExtension {

    ClaimBO: ClaimBO
    userCtx: IUsrContext

    constructor(aClaimBO: ClaimBO) {
        this.ClaimBO = aClaimBO
        this.userCtx = PAEnvironment.getValue(PAEnvironment.UserContext)

    }

    get id(): string {
        return "ClaimBOStandardWorkflowExtension"
    }

    OnLoad(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            console.log(self.id, ": OnLoad")
            aWfProcessor.setPolicyFields({
                WorkflowVisible: true,
                CurrentStateVisible: true,
                NextStateVisible: true,
                NextStateEditable: true
            })
            resolve()
        })
    }


    GetApproverPolicy(aWfProcessor: IWorkflowProcessor): Promise<ApproverPolicy> {
        return ASync.resolve(ApproverPolicy.ApproverList)
    }

    LogTransitionCondition(aWfProcessor: IWorkflowProcessor): boolean {
        const self = this

        // Always log when server side.. (Bulk Approval)
        if (PAEnvironment.isNode())
            return true;

        if (aWfProcessor.NextState.StatusTypeApproved) {
            let remaining = <number>_.round(self.ClaimBO.WB_Claim_Extended.SETTLED_AMT, 2)

            if (remaining > 100) {
                return false
            }
        }

        return true;
    }

    GetApproverList(aWfProcessor: IWorkflowProcessor): Promise<WB_UserRow[]> {
        let aWp: WorkflowProcessor = <WorkflowProcessor>aWfProcessor
        const self = this

        return new Promise<WB_UserRow[]>((resolve, error) => {


            let wbCustId = self.ClaimBO.WB_Claim.cif.WB_CUST_ID_CLAIM || self.ClaimBO.WB_Claim.cif.WB_CUST_ID_PLANNING
            let wbPeriodId = 0
            UserSecurityService.getResponsibleUserList(wbCustId, wbPeriodId, [Role_TPM_Claim_Approver, Role_Super_User], [], 0)
                .then((usersIds) => {
                    if (_.isEmpty(usersIds)) {
                        resolve([])
                        return
                    }

                    return aWfProcessor.dbContext.findUsingCache(esWB_User, usersIds)
                })
                .then((userRecs: WB_UserRow[]) => {
                    resolve(userRecs)
                })
                .catch((err) => {
                    error(err)
                })

        })

    }


    Validate(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): Promise<void> {
        const self = this
        const opts: IWorkflowValidateTransitionOptions = options || {}

        return new Promise<void>((resolve, error) => {
            // Determine if we defer the validation
            self._validate(aWfProcessor, opts)
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    //<editor-fold desc="Validate Functions">

    private _validate(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateTransitionOptions): Promise<void> {
        const self = this
        const opts = options || {}

        return new Promise<void>((resolve, error) => {

            //  Validate only State Transitions
            let NextState = aWfProcessor.NextState

            // Check if Next State is overriden.
            if (opts.UsingNextState) {
                NextState = opts.UsingNextState
            } else if (opts.UsingNextStateType) {
                let optsState = aWfProcessor.getStateType(opts.UsingNextStateType)
                if (_.isArray(optsState)) {
                    optsState = _.first(optsState)
                }
                if (optsState) {
                    NextState = optsState
                }
            }
            let NextStateId = NextState.cif.WB_STATUS_ID

            if (aWfProcessor.CurrentStateId == NextStateId) {
                resolve()
                return
            }

            let validateFunction: (a: IWorkflowProcessor) => Promise<void> = undefined

            switch (true) {
                case NextState.StatusTypeInitial:
                case NextState.StatusTypeRejected:
                case NextState.StatusTypeRevisionDenied:
                    // No Validation
                    break;

                case NextState.StatusTypeApproved:
                    // Add Validation Function
                    validateFunction = self._validateStateTransition_Approved.bind(self);
                    break;

                case NextState.StatusTypePendingApproval:
                case NextState.StatusTypeRevised:
                    // No Validation
                    break;

                case NextState.StatusTypeCancelled:
                    validateFunction = self._validateStateTransition_Cancel.bind(self);
                    break;

                case NextState.StatusTypeClosed:
                    validateFunction = self._validateStateTransition_Closed.bind(self)
                    break;
            }

            if (!_.isFunction(validateFunction)) {
                resolve()
                return
            }

            validateFunction(aWfProcessor)
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })

        })
    }

    private _validateStateTransition_Approved(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            let arrApprovalWarningMessageTexts: string[] = []

            if (arrApprovalWarningMessageTexts.length) {
                let sMsg = arrApprovalWarningMessageTexts.join("\n")
                WarningMessage_restate(self.ClaimBO.ValidateMessageProvider, true, "ApprovalWarnings", {
                    Title: "Approval Warnings",
                    Desc: sMsg
                })
            }
            resolve()
        })

    }

    private _validateStateTransition_Cancel(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            resolve()
        })
    }

    private _validateStateTransition_Closed(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            resolve()
        })

    }


    //</editor-fold>


    OnValidatationSucess(aWfProcessor: IWorkflowProcessor, options?: IWorkflowValidateOptions): Promise<void> {
        const self = this
        const opts = options || {}

        return new Promise<void>((resolve, error) => {

            let NextState = aWfProcessor.NextState
            let NextStateId = NextState.cif.WB_STATUS_ID

            let onValidateSuccessFunction: (a: IWorkflowProcessor) => Promise<void> = undefined

            switch (true) {
                case NextState.StatusTypeInitial:
                case NextState.StatusTypeRejected:
                case NextState.StatusTypeRevisionDenied:
                    // No Function
                    break;

                case NextState.StatusTypeApproved:
                    // Add Validation Function
                    onValidateSuccessFunction = self._onValidateSuccess_Approved.bind(self);
                    break;

                case NextState.StatusTypePendingApproval:
                case NextState.StatusTypeRevised:
                    // No Validation
                    break;

                case NextState.StatusTypeCancelled:
                    onValidateSuccessFunction = self._onValidateSuccess_Cancel.bind(self);
                    break;

                case NextState.StatusTypeClosed:
                    onValidateSuccessFunction = self._onValidateSuccess_Closed.bind(self)
                    break;
            }

            if (!_.isFunction(onValidateSuccessFunction)) {
                resolve()
                return
            }

            onValidateSuccessFunction(aWfProcessor)
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    //<editor-fold desc="OnValidate Success Functions">
    private _onValidateSuccess_Approved(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            resolve()
        })
    }

    private _onValidateSuccess_Closed(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            self.ClaimBO.WB_Claim_Extended.REJECTED_AMT = self.ClaimBO.WB_Claim_Extended.REMAINING_AMT
            self.ClaimBO.WB_Claim_Extended.REMAINING_AMT = 0
            resolve()
        })
    }

    private _onValidateSuccess_Cancel(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this
        return new Promise<void>((resolve, error) => {
            resolve()

        })
    }

    //</editor-fold>


    OnSaved(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {

            let primaryWfProcessor: IWorkflowProcessor = undefined
            let bExit = false

            if (!_.isEmpty(primaryWfProcessor)) {
                // primaryWfProcessor = self.ClaimBO.PrimaryWorkflowProcessor

                primaryWfProcessor.Validate({})
                    .then((ignore) => {
                        self.ClaimBO.ValidateMessageProvider.addMessages(primaryWfProcessor.WorkflowMessageProvider.Messages)
                        if (primaryWfProcessor.WorkflowMessageProvider.countMessages(MessageType.Error) > 0) {
                            // Done Save
                            bExit = true
                            return
                        }
                        return primaryWfProcessor.Save(false)
                    })
                    .then((ignore) => {
                        resolve()
                    })
                    .catch((err) => {
                        error(err)
                    })
            }
        })

    }

    OnReloaded(aWfProcessor: IWorkflowProcessor): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            console.log(self.id, ": OnReloaded")
            resolve()
        })
    }


}
